<template>
  <div class="admin">
    <Header />
    <div class="content">
      <router-view></router-view>
    </div>
    <!-- <Chat /> -->
    <div class="teste" v-if="env != 'prod'">PORTAL TESTE</div>
    <Status />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { env } from "@/conf/conf.js";
/* import Chat from "@/components/Chat.vue"; */
import Header from "@/components/HeaderAdmin.vue";
import Status from "@/components/Status.vue";

export default {
  name: "Admin",
  components: {
    /* Chat, */
    Header,
    Status,
  }, data() {
    return { env: env };
  },
  methods: {
    ...mapActions("user", ["CONF"]),
  },
  beforeMount() {
    this.CONF().then(r => {
      if (r && r.data && r.data.app_version) {

        let version = parseInt(r.data.app_version)
        let ov = localStorage.getItem("VERSION") || 0

        if (version > parseInt(ov)) {
          localStorage.setItem("VERSION", version)
          window.location.reload(true)
        }
      }
    })
  },
};
</script>

<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.admin
  /* .config
    padding: 42px 35px
    @media (max-width: $small)
      padding: 7px */
  .teste
    background: red
    padding: 12px 20px
    text-align: center
    font-size: 28px
    position: fixed
    bottom: 0
    left: 0
    opacity: .8
    color: white
    border-top-right-radius: 12px
    box-shadow: $shadow
    z-index: 999
  *:required:invalid
    border-bottom: 3px solid $red
  input, textarea, select
      height: 44px
      padding: 0 8px
      border: none
      width: 92%
      border-bottom: 3px solid #ddd
      border-radius: 8px
      box-shadow: none
      background: none
      &:focus
        background: rgba($purple,.1)
        border-bottom: 3px solid $purple
  input[type='checkbox']
    width: 18px
    height: 18px
  textarea
    min-height: 160px
    padding-top: 12px
  h1
    font-size: 25px
    text-transform: uppercase
    letter-spacing: 2.7px
    color: $purple
</style>
